import ACTIONS from "../actions/types";

const initialState = {
  int_selectedDevices: [],
  int_systems: [],
  int_selectedSystem: {},
  int_selectedClient: {},
  int_systemClients: [],
  int_clientIntegratedDevices: [],
  integrationMsg: "",
  integrationStatus: false,
  isFetchingSystems: true,
  isFetchingClients: true,
  isFetchingDevices: true,
  isFetchingIntegratedDevices: true,
  isIntegrationStarted: false,
  isCompactView: false,
};

const integrationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.INTEGRATION.SET_SELECTED_DEVICES:
      return {
        ...state,
        int_selectedDevices: [...payload],
      };
    case ACTIONS.INTEGRATION.SET_NO_SELECTED_DEVICES:
      return {
        ...state,
        int_selectedDevices: [],
      };

    case ACTIONS.INTEGRATION.SET_SELECTED_SYSTEMS:
      return {
        ...state,
        int_selectedSystem: { ...payload },
      };

    case ACTIONS.INTEGRATION.SET_SELECTED_CLIENT:
      return {
        ...state,
        int_selectedClient: { ...payload },
      };

    case ACTIONS.INTEGRATION.SET_SELECTED_SYSTEM_CLIENTS:
      return {
        ...state,
        int_systemClients: [...payload],
        isFetchingClients: false,
      };

    case ACTIONS.INTEGRATION.SET_SELECTED_SYSTEM_CLIENTS_FAILURE:
      return {
        ...state,
        int_systemClients: [],
        isFetchingClients: false,
      };

    case ACTIONS.INTEGRATION.SET_SELECTED_DEVICES_FAILURE:
      return {
        ...state,
        int_selectedDevices: [],
      };

    case ACTIONS.INTEGRATION.SET_INTEGRATIONS_SYSTEMS:
      return {
        ...state,
        int_systems: [...payload],
        isFetchingSystems: false,
      };

    case ACTIONS.INTEGRATION.SET_INTEGRATIONS_SYSTEMS_FAILURE:
      return {
        ...state,
        int_systems: [],
        isFetchingSystems: false,
      };

    case ACTIONS.INTEGRATION.SET_INTEGRATIONS_CLIENT_INTEGRATED_DEVICES:
      return {
        ...state,
        int_clientIntegratedDevices: payload.reverse(),
        isFetchingIntegratedDevices: false,
      };

    case ACTIONS.INTEGRATION.SET_INTEGRATIONS_CLIENT_INTEGRATED_DEVICES_FAILURE:
      return {
        ...state,
        int_clientIntegratedDevices: [],
        integrationMsg: payload,
        integrationStatus: false,
        isFetchingIntegratedDevices: false,
      };
    case ACTIONS.INTEGRATION.INTEGRATE_NEW_DEVICES_STARTED:
      return {
        ...state,
        isIntegrationStarted: true,
      };
    case ACTIONS.INTEGRATION.INTEGRATE_NEW_DEVICES_SUCCESS:
      return {
        ...state,
        isIntegrationStarted: false,
        int_selectedDevices: [],
        integrationMsg: payload,
        integrationStatus: true,
      };
    case ACTIONS.INTEGRATION.INTEGRATE_NEW_DEVICES_FAILURE:
      return {
        ...state,
        isIntegrationStarted: false,
        integrationMsg: payload,
        integrationStatus: false,
      };
    case ACTIONS.INTEGRATION.DELETE_INTEGRATED_DEVICE_SUCCESS:
      return {
        ...state,
        isIntegrationStarted: false,
        int_clientIntegratedDevices: [...state.int_clientIntegratedDevices.filter((d) => d._id !== payload._id)],
      };
    case ACTIONS.INTEGRATION.DELETE_INTEGRATED_DEVICE_FAILURE:
      return {
        ...state,
        isIntegrationStarted: false,
      };
    case ACTIONS.INTEGRATION.TOGGLE_COMPACT_VIEW:
      return {
        ...state,
        isCompactView: !state.isCompactView,
      };
    case ACTIONS.INTEGRATION.SET_IS_COMPACT_VIEW:
      return {
        ...state,
        isCompactView: payload,
      };
    case ACTIONS.INTEGRATION.CLEAR_INTEGRATIONS:
      return {
        ...initialState,
      };

    default:
      return { ...state };
  }
};
export default integrationReducer;
